import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { useCart, brl } from "../context/CartContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BestSellers = () => {
  const [data, setData] = useState(null);
  const { add } = useCart();

  useEffect(() => {
    fetch(`${API}/featured-products`).then((r) => r.json()).then(setData).catch(() => {});
  }, []);

  if (!data || !data.products?.length) return null;
  const manual = data.mode === "featured";

  return (
    <section id="destaques" data-testid="bestsellers-section" className="bg-baby/40 py-24 md:py-32 border-y border-military/10">
      <div className="w-full max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16"
        >
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-military font-semibold mb-4">06 · Destaques</p>
            <h2 className="font-serif text-4xl md:text-6xl text-military-dark tracking-tight">
              {manual ? <>Escolhidos <span className="italic font-light text-military">a dedo.</span></> : <>Os mais <span className="italic font-light text-military">vendidos.</span></>}
            </h2>
          </div>
          <p className="text-sm text-military-dark/60 max-w-xs">
            {manual ? "Seleção manual da loja — os queridinhos da casa." : "Calculado automaticamente a partir das vendas reais."}
          </p>
          <Link to="/produtos" data-testid="bestsellers-all" className="group inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-military-dark hover:text-military transition-colors">
            Ver todos os produtos
          </Link>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {data.products.map((p, i) => {
            const onSale = p.sale_price != null && p.sale_price < p.price;
            const out = p.stock === 0;
            return (
              <motion.article
                key={p.slug}
                data-testid={`featured-${p.slug}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, ease: "easeOut", delay: i * 0.1 }}
                className="group bg-white border border-military/10 rounded-lg overflow-hidden flex flex-col"
              >
                <Link to={`/produto/${p.slug}`} className="relative block overflow-hidden aspect-square bg-offwhite">
                  <img src={p.image} alt={p.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  {out && <span className="absolute top-3 right-3 bg-military-dark text-offwhite text-[9px] uppercase tracking-[0.2em] font-semibold px-2.5 py-1 rounded-full">Esgotado</span>}
                  {onSale && !out && <span className="absolute top-3 right-3 bg-military text-offwhite text-[9px] uppercase tracking-[0.2em] font-semibold px-2.5 py-1 rounded-full">Promoção</span>}
                </Link>
                <div className="p-5 flex flex-col flex-1">
                  <p className="text-[10px] uppercase tracking-[0.2em] text-military font-semibold mb-1.5">{p.category}</p>
                  <Link to={`/produto/${p.slug}`} className="font-serif text-xl text-military-dark leading-tight mb-3 hover:text-military transition-colors">{p.name}</Link>
                  <div className="mt-auto flex items-center justify-between gap-3">
                    <p className="text-sm font-semibold text-military-dark">
                      {onSale && <span className="block text-xs text-military-dark/40 line-through font-normal">{brl(p.price)}</span>}
                      {brl(onSale ? p.sale_price : p.price)}
                    </p>
                    {!out && (
                      <button
                        data-testid={`featured-add-${p.slug}`}
                        onClick={() => { add({ ...p, price: onSale ? p.sale_price : p.price }); toast.success(`${p.name} adicionado à sacola`); }}
                        className="flex items-center gap-1.5 rounded-full bg-military-dark text-offwhite px-4 py-2 text-[10px] uppercase tracking-widest font-semibold hover:bg-military transition-colors"
                      >
                        <Plus size={12} /> Add
                      </button>
                    )}
                  </div>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
